/**
 * Embed-only sidebar scoping: keep threads that resolve to the handed-off
 * CMMD organization id via the existing workspaceScoping indexes (forge#3572).
 */

import type { SidebarThreadSummary } from "~/types";

import {
  resolveThreadWorkspaceKey,
  type WorkspaceRef,
} from "../components/sidebar/workspaceScoping";

export function filterThreadsToEmbedWorkspace(input: {
  readonly threads: ReadonlyArray<SidebarThreadSummary>;
  readonly workspaceId: number;
  readonly taskWorkspaceIndex: ReadonlyMap<string, WorkspaceRef>;
  readonly projectWorkspaceIndex: ReadonlyMap<string, WorkspaceRef>;
  readonly campaignWorkspaceIndex: ReadonlyMap<string, WorkspaceRef>;
  readonly workspaceKeyByTaskTitle: ReadonlyMap<string, string>;
}): readonly SidebarThreadSummary[] {
  const expected = String(input.workspaceId);
  return input.threads.filter((thread) => {
    const key = resolveThreadWorkspaceKey({
      thread,
      taskWorkspaceIndex: input.taskWorkspaceIndex,
      projectWorkspaceIndex: input.projectWorkspaceIndex,
      campaignWorkspaceIndex: input.campaignWorkspaceIndex,
      workspaceKeyByTaskTitle: input.workspaceKeyByTaskTitle,
    });
    return key === expected;
  });
}

export function projectMatchesEmbedWorkspace(input: {
  readonly workspaceIdentityId: string | null | undefined;
  readonly workspaceId: number;
}): boolean {
  if (input.workspaceIdentityId == null || input.workspaceIdentityId.trim() === "") {
    return true;
  }
  return input.workspaceIdentityId === String(input.workspaceId);
}
